export { default } from './page'
